<template>
  <div>
    <v-card id="card" class="card-text px-1 rounded-0" color="" style="">
      <v-row>
        <v-col class="my-auto py-0" @click="clickItem">
          <v-row>
            <v-col cols="">
              <v-row>
                <v-col cols="6" class="">
                  <div class="d-flex flex-column">
                    <span>{{ item.personName }}</span>
                    <span class="text-muted"
                      >({{ $t("card-no") }}:{{ item.PERNO }})</span
                    >
                  </div>
                </v-col>
                <v-col cols="6" class=""
                  >{{ $t("EntryDate") }}:
                  <span class="text-value">{{ item.beginDate }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="d-flex my-auto py-0" cols="auto">
          <v-btn icon @click="show = !show" class="card-text">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-expand-transition class="">
        <div v-show="show" class="mt-1">
          <v-row @click="clickItem">
            <v-col>
              <v-row>
                <v-col cols="6" class="my-auto"
                  >{{ $t("DayName") }} :
                  <span class="text-value">{{ item.enterDayName }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{ $t("EntryTime") }} :
                  <span class="text-value">{{ item.BeginTime }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{ $t("ExitDate") }} :
                  <span class="text-value">{{ item.endDate }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{ $t("ExitTime") }} :
                  <span class="text-value">{{ item.endTime }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{ $t("type") }} :
                  <span class="text-value">{{ item.type }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{ $t("status") }} :
                  <span class="text-value">{{ item.position }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{ $t("statusName") }} :
                  <span class="text-value">{{ item.status }}</span>
                </v-col>
                
              </v-row>
            </v-col>
            <v-col cols="auto py-0">
              <div style="width: 36px; height: 36px"></div>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {},
  data() {
    return {
      show: false,
    };
  },
  methods: {
    clickItem() {
      this.$emit("onClickItem", this.item);
    },
  },
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>